import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=ded71964&scoped=true&"
import script from "./MessagePage.vue?vue&type=script&lang=js&"
export * from "./MessagePage.vue?vue&type=script&lang=js&"
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=ded71964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded71964",
  null
  
)

export default component.exports